import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleEssentialOnly = () => {
    localStorage.setItem("cookie-consent", "essential-only");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="max-w-5xl mx-auto bg-bg-card border border-border rounded-2xl shadow-2xl p-6 md:p-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-5 md:gap-8">
          <div className="flex-1">
            <h3 className="font-sans text-[17px] font-semibold text-text-headline mb-2 flex items-center gap-2">
              <i className="ri-shield-check-line text-primary w-5 h-5 flex items-center justify-center" />
              Cookie Preferences
            </h3>
            <p className="font-sans text-[14px] md:text-[15px] text-text-muted leading-relaxed">
              We use only essential cookies required for this site to function. No tracking or advertising cookies are used. You can learn more in our{" "}
              <a href="/privacy" className="text-primary hover:underline font-medium">
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <div className="flex items-center flex-shrink-0 w-full md:w-auto">
            <button
              onClick={handleEssentialOnly}
              className="font-sans text-[14px] font-medium text-white bg-primary hover:bg-primary-light px-6 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer w-full md:w-auto"
            >
              Only Essential Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}